import React from 'react';
import 'rc-dialog/assets/bootstrap.css';


class Adicionales extends React.Component {

    constructor( props ) {
        super( props );
        this.state = {
            buscarCliente: '',
            editando: this.props.tarjetas.clienteTarjeta,
            buscando:false,
            noEncontrado:false,
            modalAdicional:false,
            buscoClienteRepetido:false,
            mensajeClienteRepetido:"",
            esPersonaJuridica:false
        };
        this.handleClick = this.handleClick.bind(this);
    }

    handleChangeBuscarCliente(e) {
        this.setState({ buscarCliente: e.target.value });
        this.props.onBlurTextBox("buscarCliente", e.target.value);
    }

    handleClick(){
        let adicionales =[];
        let esCuentaIndividuo = this.props.tarjetas.tipoEmpresa.EmpresaIndividuos =="I";
        let adicionalYaExiste = false;
        let titularRepetido = false;


        adicionales = this.props.data.cuentasAdicionales ? JSON.parse(JSON.stringify(this.props.data.cuentasAdicionales)) : JSON.parse(JSON.stringify(this.props.data.adicionales));

        if(esCuentaIndividuo){
            // si es cuenta individuo, a los adicionales hay que agregarle el titular
            adicionales.push({Cuit:parseInt(this.props.tarjetas.clienteResultadoBusqueda.Cuit), Titular:true})
        }

        adicionales.map(adicional=>{
            if(adicional.Cuit == parseInt(this.state.buscarCliente) || adicional.ClienteTarjetas && adicional.ClienteTarjetas.Cuit == parseInt(this.state.buscarCliente)){
                adicionalYaExiste = true
                //condición para cambiar el mensaje de error
                if(adicional.Titular) titularRepetido = true
            }
        })
        
        if(!adicionalYaExiste){
            if(this.state.buscarCliente.length>0 && !isNaN(parseInt(this.state.buscarCliente)) ){
                if(this.props.pantallaActual == "NuevaSolicitudCuenta"){
                    this.props.buscarPorCuit(this.state.buscarCliente,true);
                    this.setState({buscando:true,noEncontrado:false})
                    
                }else if(this.props.pantallaActual=="NuevaSolicitudAdicional"){
                    
                    if(this.props.tarjetas.clienteTarjeta == null){
                        this.props.buscarPorCuit(this.state.buscarCliente,true);
                        this.setState({modalAdicional:true})
                    }else if(this.props.tarjetas.clienteTarjeta != null){
                        this.props.toggleModal("CancelarEdicionActual");
                    }
                }
            }
            this.setState({buscoClienteRepetido:false,buscarCliente:""})
        }else{
            let mensajeAdicionalRepetido = "El cliente ya se encuentra registrado como " + (esCuentaIndividuo ? (titularRepetido ? "titular." : "adicional.") : "extensión.")
            this.setState({buscoClienteRepetido:true, mensajeClienteRepetido : mensajeAdicionalRepetido})
        }
    }

    componentDidUpdate(){
        const {tarjetas,data} = this.props;
        let producto = {}

        if(tarjetas.administradora.Id == 1){
            producto = data.GET_PRODUCTO_VISA_PRODUCTO_ID
        }else if(tarjetas.administradora.Id == 2){
            producto = data.GET_PRODUCTO_CABAL_PRODUCTO_ID  
        }

        if(!this.props.tarjetas.vuelveDeAdicional && tarjetas.solicitudCuenta && producto && producto.Id && tarjetas.esModificacion && !data.tarjetaTitularModificacion && tarjetas.tipoEmpresa.EmpresaIndividuos == "E"){
            if(tarjetas.cuentasAdicionales.length>0 && (!tarjetas.solicitudCuenta.cuentasAdicionales  ||tarjetas.solicitudCuenta.cuentasAdicionales.length == 0)){
                this.props.cargarAdicionalesModificacion();
            }else{
                this.props.cargarDatosModificacion("tarjetaTitularModificacion");
            }
        }
        if(this.props.pantallaActual == "NuevaSolicitudCuenta" && this.props.tarjetas.clienteTarjeta && this.props.tarjetas.clienteTarjeta.DatosClientes && !this.props.tarjetas.errorWSClienteAdicional && !this.props.tarjetas.loadingCliente){
            //retrasa la aparición del modal de datos del cliente hasta que efectivamente se haya cargado un cliente
            if(this.props.tarjetas.clienteTarjeta.DatosClientes && this.props.tarjetas.clienteTarjeta.DatosClientes.TipoPersona=="J"){
                this.props.confirmarClienteTarjeta(false)
                this.setState({esPersonaJuridica:true})
            }else{
                this.props.toggleModal("NuevaSolicitudCuenta");
            }
        }
        if(this.props.pantallaActual != "NuevaSolicitudCuenta" && this.props.tarjetas.clienteTarjeta && this.props.tarjetas.clienteTarjeta.DatosClientes && !this.props.tarjetas.errorWSClienteAdicional && !this.props.tarjetas.loadingCliente && this.state.modalAdicional){
            //retrasa la aparición del modal de datos del cliente hasta que efectivamente se haya cargado un cliente
            if(this.props.tarjetas.clienteTarjeta.DatosClientes && this.props.tarjetas.clienteTarjeta.DatosClientes.TipoPersona=="J"){
                this.props.confirmarClienteTarjeta(false)
                this.setState({esPersonaJuridica:true})
            }else{
            this.props.toggleModal("SolicitudAltaDeCuenta");
            this.setState({modalAdicional:false})
            }
        }
    }

    render() {

        const { data, tarjetas } = this.props;
        
        let cuentaTipo = tarjetas && tarjetas.tipoEmpresa ? tarjetas.tipoEmpresa.EmpresaIndividuos : "I"
        let tituloCuentaTipo = cuentaTipo == "E" ?  "Agregar Extensión" : "Agregar Adicional"
        let productoSeleccionado = tarjetas && tarjetas.administradora.Id == 1 ? data.GET_PRODUCTO_VISA_PRODUCTO_ID : data.GET_PRODUCTO_CABAL_PRODUCTO_ID;
        let permiteRedirect = false;
        
        //PARA EVITAR ERRORES EN ADICIONALES POR FALTANTE DE DATOS NECESARIOS PARA LA CARGA DE LA VISTA, SE VALIDA ANTES DE DAR FUNCIONALIDAD AL BOTÓN QUE REDIRECCIONA
        if(this.props.pantallaActual == "NuevaSolicitudCuenta"){
            if(productoSeleccionado && productoSeleccionado.Id ){
                if((tarjetas.administradora.Id == 1 && data.modeloDistribucionId) || tarjetas.administradora.Id == 2 ){
                    if(tarjetas.tipoEmpresa.EmpresaIndividuos == "I"){
                        permiteRedirect = !([null, 0, "",undefined].some(s => s === data.denominacion1));
                        permiteRedirect = !([null, 0, "",undefined].some(s => s === data.denominacion2));
                    }else{
                        permiteRedirect = true
                    }
                }
            }
        }else{
            permiteRedirect = true
        }
        
        return (
            <div className="row">
                {this.props.tarjetas.loadingCliente && <div className="loading" />}
                <div className="col-md-12">
                    <div className="row">
                        <div className="correspondencia-contacto-cliente col-md-12">
                            <div className="divisor-section bottom-separator" >
                                <h2>Adicionales / Cuentas de Extensión</h2>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <label className="label-primary">
                                Titular
                                    </label>

                            <div className="form-group  input-icon-container">
                                <span className="ti-search-new input-icon-span-new"></span>
                                <input className="textbox-rectangular form-control default-input top-separator-xxxs bottom-separator-xxs in-adicional busqueda-alta-new" id="buscarCliente" value={this.state.buscarCliente} onChange={this.handleChangeBuscarCliente.bind(this)} type="text" placeholder="Buscar por Nombre, Documento o CUIT/CUIL..." />
                                {!this.props.tarjetas.loadingCliente && this.props.tarjetas.errorWSClienteAdicional
                                ? <div className="client-search-div-result-adicionales">
                                    <label className="client-search-label-secondary">{this.props.tarjetas.errorWSClienteAdicional}</label>
                                </div>
                                : null}
                                {this.state.buscoClienteRepetido
                                ? <div className="client-search-div-result-adicionales">
                                    <label className="client-search-label-secondary">{this.state.mensajeClienteRepetido}</label>
                                </div>
                                : null}
                                {this.state.esPersonaJuridica
                                ? <div className="client-search-div-result-adicionales">
                                    <label className="client-search-label-secondary">"Una persona jurídica no puede integrar la cuenta en calidad de adicional/extensión de cuenta, sólo personas humanas"</label>
                                </div>
                                : null}

                                {   permiteRedirect ?
                                    <button  id="btnDataCliente" className="btn btn-cta btn-adicional" type="button"  onClick={this.handleClick} /*dataTarget="#SolicitudAltaDeCuenta" */>{tituloCuentaTipo}</button>:
                                    <button disabled="true" className="btn btn-secondary btn-adicional" type="button">{tituloCuentaTipo}</button>                               
                                }
  
                                
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Adicionales;